export const capitalizeWord = (word: string) => {
  const lcWord = word.toLowerCase();
  return lcWord.charAt(0).toUpperCase() + lcWord.slice(1);
};
